import styled, { css } from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";

export const Card = styled.div<{ $selected: boolean; $disabled: boolean }>`
  display: flex;
  flex-direction: column;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  padding: ${({ theme }) => theme.space.card.inset}px;
  border-radius: ${({ theme }) => theme.radius.md}px;
  background: ${({ theme }) => theme.colors.ui.background.raised};
  border: ${({ theme }) => theme.stroke.selected}px solid
    ${({ theme }) => theme.colors.ui.border.default};
  opacity: ${({ theme, $disabled }) =>
    $disabled ? theme.opacity.disabled : theme.opacity.default};

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      background: ${theme.colors.ui.background.page};
      border-color: ${theme.colors.ui.border.strong};
    `}

  ${({ theme, $selected }) =>
    $selected &&
    css`
      border-color: ${theme.mode === "dark"
        ? theme.colors.ui.border.selected
        : theme.colors.ui.border.brand};
      background: ${theme.mode === "dark"
        ? theme.colors.ui.background.page
        : theme.colors.ui.interactive.primaryDeepTintSubtle};
    `}

  &:focus-visible {
    outline: ${({ theme }) => theme.stroke.focus}px solid
      ${({ theme }) => theme.colors.ui.border.focus};
    outline-offset: ${({ theme }) => theme.stroke.focus}px;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space.md}px;
`;

export const Indicator = styled.span<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: ${({ theme }) => 18}px;
  height: ${({ theme }) => 18}px;
  border-radius: ${({ theme }) => theme.radius.full}px;
  border: ${({ theme }) => theme.stroke["selection-control"].default}px solid
    ${({ theme, $selected }) => {
      if (!$selected) return theme.colors.ui.border.strong;
      return theme.mode === "dark"
        ? theme.colors.ui.border.selected
        : theme.colors.ui.border.brand;
    }};
`;

export const IndicatorCore = styled.span`
  width: ${({ theme }) => theme.size.indicator.pagination.dot}px;
  height: ${({ theme }) => theme.size.indicator.pagination.dot}px;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: ${({ theme }) => theme.colors.ui.interactive.primary};
`;

export const Main = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: ${({ theme }) => theme.space["2xs"]}px;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.sm}px;
`;

export const Title = styled.span`
  ${typographyCSS("heading.2xs")}
  color: ${({ theme }) => theme.colors.ui.text.primary};
`;

export const Description = styled.span`
  ${typographyCSS("body.sm")}
  color: ${({ theme }) => theme.colors.ui.text.secondary};
`;

export const Trailing = styled.div`
  display: flex;
  align-items: center;
  flex: none;
`;

export const Footer = styled.div`
  margin-top: ${({ theme }) => theme.space.md}px;
  padding-top: ${({ theme }) => theme.space.md}px;
  border-top: ${({ theme }) => theme.stroke.md}px solid
    ${({ theme }) => theme.colors.ui.border.divider};
`;
